//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';

//Material-ui
import Button from '@material-ui/core/Button';

//Part
import PartPageTitle from './PartPageTitle';


class Comp extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      appleOauthSubject: null,
      appleOauthState: null,
    }
  }

  componentDidMount() {
    document.title = 'AppleIDでログイン - パートナーズ';
    this.props.settingAppleOauthCheck((data) => {
      let state;
      if (data.subject) {
        state = true;
      }
      else {
        state = false;
      }
      this.setState({appleOauthSubject:data.subject, appleOauthState:state});
    });

    window.AppleID.auth.init({
      clientId : 'net.partners.auth',
      redirectURI : 'https://www.partner-s.net/oauth/editAppleOauth.php',
      scope: 'email',
    });
  }


  render() {

    let content;

    content = (
      <div>
        <h3 align='center' style={{padding:'10px'}}>
          AppleIDでログインとは?
        </h3>
        <div style={{maxWidth:'400px', margin:'auto'}}>
          AppleIDと連携することで、ログインする際にIDとパスワードを入力する必要がなくなります。
        </div>
        {
          (this.state.appleOauthState === true) ? (
            <div align='center'>
              <h3 style={{padding:'10px'}}>
                AppleIDは連携済です
              </h3>

              <Button
                variant="outlined"
                onClick={ () => window.AppleID.auth.signIn() }
              >
                別のAppleIDと連携する
              </Button>
              <div style={{maxWidth:'400px', margin:'auto', color:'#666' ,fontSize:'0.9em'}}>
                ブラウザ側で事前に新しく連携する<br />アカウントでログインしてください。
              </div>
            </div>
          ):(
            <div align='center'>
              <Button
                variant="outlined"
                onClick={ () => window.AppleID.auth.signIn() }
              >
                AppleIDと連携する
              </Button>
            </div>

          )
        }

      </div>
    )


    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={'AppleIDでログイン'}
          onback={ '/setting/' }
        />
        {
          content
        }
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...settingAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
